module.exports = __webpack_public_path__ + "img/big_1_49.643e0ad4.png";